<template>
  <div>
    <div>
      <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
    </div>

    <div>
      <v-form ref="form">
        <v-container>
          <v-layout wrap>
            <v-flex md2 sm12>
              <v-select :items="typeItems" v-model="selected_type"
                :label="$t('monitoring.customerAppStats.type')"></v-select>
            </v-flex>
            <v-flex md2 sm12>
              <v-select :items="filterByItems" v-model="selected_filter_by"
                :label="$t('monitoring.customerAppStats.filterBy')"></v-select>
            </v-flex>
            <v-flex md2 sm12 v-if="selected_filter_by == 'Day'">
              <choose-date clearable :label="$t('common.from')" v-model="from"></choose-date>
            </v-flex>
            <v-flex md2 sm12 v-if="selected_filter_by == 'Day'">
              <choose-date clearable :label="$t('common.to')" v-model="to"></choose-date>
            </v-flex>
            <v-flex md2 sm12 v-if="selected_filter_by == 'Month'">
              <date-picker-multiple v-model="selected_month" />
            </v-flex>
            <v-flex md2 sm12 v-if="selected_filter_by == 'Year'">
              <v-select :items="years" item-text="Year" v-model="selected_year" :label="$t('monitoring.customerAppStats.selectYear')"></v-select>
            </v-flex>
            <!--<v-flex md2 sm12>
              <v-btn color="primary" dark class="mb-2 cbtn" @click="getData(true)" :loading="loading">Export
                PDF</v-btn>
            </v-flex>-->
          </v-layout>
        </v-container>
      </v-form>
    </div>
    <v-container fluid class="stats-container">
      <!-- Bookings Stats Section -->
      <v-card class="mb-4" elevation="2">
        <v-card-title class="primary white--text">
          {{ $t("monitoring.customerAppStats.bookingsStatistics") }}
        </v-card-title>
        <v-card-text>
          <v-layout row wrap v-if="Object.keys(bookingsStats).length > 0">
            <v-flex xs12 sm6 md4 lg3 v-for="(stat, index) in bookingsStats"
              v-if="!['static_constraints', 'captain_cancellation_reason', 'user_cancellation_reason','number_of_different_customers'].includes(index)"
              :key="index" class="pa-2">
              <v-card class="stat-card" elevation="1" :class="getStatCardClass(index)">
                <v-card-text class="pa-3">
                  <div class="stat-label">{{ formatLabel(index) }}</div>
                  <div class="stat-value">{{ formatValue(stat) }}</div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <div v-else class="text-center pa-4">
            
            <v-icon large color="grey lighten-1">mdi-chart-line</v-icon>
            <p class="grey--text mt-2">{{ $t("monitoring.customerAppStats.noBookingsData") }}</p>
          </div>
        </v-card-text>
      </v-card>

      <!-- Customer Stats Section -->
      <v-card class="mb-4" elevation="2">
        <v-card-title class="teal white--text">
          {{ $t("monitoring.customerAppStats.customerStatistics") }}
        </v-card-title>
        <v-card-text>
          <v-layout row wrap v-if="Object.keys(customerStats).length > 0">
            <v-flex xs12 sm6 md4 lg3 v-for="(stat, index) in customerStats"
              v-if="!['static_constraints', 'captain_cancellation_reason', 'user_cancellation_reason'].includes(index)"
              :key="index" class="pa-2">
              <v-card class="stat-card" elevation="1" :class="getStatCardClass(index)">
                <v-card-text class="pa-3">
                  <div class="stat-label">{{ formatLabel(index) }}</div>
                  <div class="stat-value">{{ formatValue(stat) }}</div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <div v-else class="text-center pa-4">
            
            <v-icon large color="grey lighten-1">mdi-chart-line</v-icon>
            <p class="grey--text mt-2">{{ $t("monitoring.customerAppStats.noBookingsData") }}</p>
          </div>
        </v-card-text>
      </v-card>

      <!-- Payments Stats Section -->
      <v-card class="mb-4" elevation="2">
        <v-card-title class="success white--text">
          {{ $t("monitoring.customerAppStats.paymentsStatistics") }}
        </v-card-title>
        <v-card-text>
          <v-layout row wrap v-if="Object.keys(paymentsStats).length > 0">
            <v-flex xs12 sm6 md4 lg3 v-for="(stat, index) in paymentsStats"
              v-if="!['static_constraints', 'captain_cancellation_reason', 'user_cancellation_reason'].includes(index)"
              :key="index" class="pa-2">
              <v-card class="stat-card" elevation="1" :class="getStatCardClass(index)">
                <v-card-text class="pa-3">
                  <div class="stat-label">{{ formatLabel(index) }}</div>
                  <div class="stat-value">{{ formatPaymentValue(stat, index) }}</div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <div v-else class="text-center pa-4">
            <v-icon large color="grey lighten-1">mdi-cash</v-icon>
            <p class="grey--text mt-2">{{ $t("monitoring.customerAppStats.noPaymentsData") }}</p>
          </div>
        </v-card-text>
      </v-card>

      <!-- Top Countries Section -->
      <v-card class="mb-4" elevation="2">
        <v-card-title class="info white--text">
          {{ $t("monitoring.customerAppStats.topCountries") }}
        </v-card-title>
        <v-card-text>
          <v-layout row wrap v-if="Object.keys(topCountries).length > 0">
            <v-flex xs12 sm6 md4 lg3 v-for="(stat, index) in topCountries"
              v-if="!['static_constraints', 'captain_cancellation_reason', 'user_cancellation_reason'].includes(index)"
              :key="index" class="pa-2">
              <v-card class="stat-card country-card" elevation="1">
                <v-card-text class="pa-3">
                  <div class="stat-label">{{ formatLabel(index) }}</div>
                  <div class="stat-value">{{ formatValue(stat) }}</div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <div v-else class="text-center pa-4">
            <v-icon large color="grey lighten-1">mdi-earth</v-icon>
            <p class="grey--text mt-2">{{ $t("monitoring.customerAppStats.noCountriesData") }}</p>
          </div>
        </v-card-text>
      </v-card>
    </v-container>

  </div>
</template>

<style lang="scss"></style>

<script>
import ChooseDate from "@/components/monaco/input/ChooseDate";
import DatePickerMultiple from "@/components/monaco/input/DatePickerMultiple";

export default {
  name: "CustomerAppStats",
  title() {
    return this.$t("monitoring.customerAppStats.title");
  },
  components: { ChooseDate, DatePickerMultiple },
  data() {
    return {
      selected_type: "All",
      filterBy: ["Day", "Month", "Year"],
      from: null,
      to: null,
      selectedYear: null,
      selected_filter_by: "Day",
      selected_day: null,
      selected_month: null,
      selected_year: null,
      custom_month: null,
      custom_year: null,
      selected_type: "All",
      reservation: true,
      instant: true,
      loading: false,
      years: [],
      bookingsStats: [],
      paymentsStats: [],
      customerStats: [],
      topCountries: []
    };
  },

  computed: {
    typeItems() {
      return [
        { text: this.$t("common.all"), value: "All" },
        { text: this.$t("monitoring.customerAppStats.reservation"), value: "Reservation" },
        { text: this.$t("monitoring.customerAppStats.instant"), value: "Instant" },
      ];
    },
    filterByItems() {
      return this.filterBy.map((value) => ({
        text: this.$t(`monitoring.customerAppStats.filterByOptions.${value}`),
        value,
      }));
    },
  },
  watch: {
    selected_month(val) {
      (this.from = moment(val).startOf("month").format("YYYY-MM-DD")),
        (this.to = moment(val).endOf("month").format("YYYY-MM-DD")),
        this.getData(false);
    },
    selected_year(val) {
      (this.from = moment(val, "YYYY").startOf("year").format("YYYY-MM-DD")),
        (this.to = moment(val, "YYYY").endOf("year").format("YYYY-MM-DD")),
        this.getData(false);
    },
    selected_day(val) {
      // console.log(val);
      this.from = moment(val).format("YYYY-MM-DD");
      this.to = moment(val).format("YYYY-MM-DD");
      this.getData(false);
    },
    from(val) {
      if (this.selected_filter_by == "Day" && val != null && this.to != null) {
        this.getData(false);
      }
    },
    to(val) {
      if (this.selected_filter_by == "Day" && val != null && this.from != null) {
        if (this.from == null) this.from = this.to;
        this.getData(false);
      }
    },
    selected_type(val) {
      // console.log(val);
      this.reservation = true;
      this.instant = true;
      if (val == "Reservation") this.instant = false;
      else if (val == "Instant") this.reservation = false;
      this.getData(false);
    },
  },
  mounted() {
    const currentYear = new Date().getFullYear();
    this.years = Array.from({ length: 100 }, (v, i) => currentYear - i);
    this.selected_day = moment().format("YYYY-MM-DD");
    this.from = this.selected_day;
    this.to = this.selected_day;
  },
  methods: {
    getData(pdf) {
      this.loading = true;
      const params = new URLSearchParams();
      params.append("from", this.from);
      params.append("to", this.to);
      params.append("reservation", this.reservation ? 1 : 0);
      params.append("instant", this.instant ? 1 : 0);
      params.append("pdf", pdf ? 1 : 0);
      this.axios
        .get("customer_app_report", {
          responseType: pdf ? "blob" : "json",
          params: params,
        })
        .then((res) => {

          if (pdf == false) {
            this.bookingsStats = res.data.data.bookingsStats;
            this.paymentsStats = res.data.data.paymentsStats;
            this.customerStats = res.data.data.customerStats;
            this.topCountries = res.data.data.topCountries;

            let orders_paid_inside = this.bookingsStats.orders_paid_inside;
            let customer_app_completed_orders = this.bookingsStats.customer_app_completed_orders;


            this.bookingsStats.customer_app_completed_orders = this.addPercentage(this.bookingsStats.customer_app_completed_orders, this.bookingsStats.all_completed_orders)
            this.bookingsStats.customer_app_cancelled_orders = this.addPercentage(this.bookingsStats.customer_app_cancelled_orders, this.bookingsStats.customer_app_total_orders)

            this.bookingsStats.orders_per_customer = (this.bookingsStats.number_of_different_customers ? (customer_app_completed_orders / this.bookingsStats.number_of_different_customers) : 0).toFixed(2);

            this.bookingsStats.orders_paid_outside = this.addPercentage(this.bookingsStats.orders_paid_outside, customer_app_completed_orders)
            this.bookingsStats.orders_paid_inside = this.addPercentage(this.bookingsStats.orders_paid_inside, customer_app_completed_orders)

            this.paymentsStats.average_amount_per_order = (orders_paid_inside ? (this.paymentsStats.total_paid_amount / orders_paid_inside) : 0).toFixed(2);
            this.paymentsStats.average_tips_per_order = (orders_paid_inside ? (this.paymentsStats.total_tip_amount / orders_paid_inside) : 0).toFixed(2);
            let difference = this.paymentsStats.total_tip_amount + this.paymentsStats.total_cancellation_amount - this.paymentsStats.total_payment_fee_amount;
            this.paymentsStats.difference = difference > 0 ? "+" + difference : difference;
            this.customerStats.number_of_different_customers = this.bookingsStats.number_of_different_customers;


          } else {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "CustomerAppReport.pdf");
            document.body.appendChild(link);
            link.click();
          }
          this.loading = false;
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err, "red");
          this.loading = false;
        });
    },
    addPercentage(val1, val2) {
      let percentage = (val2 ? (val1 * 100 / val2) : 0).toFixed(2);
      return val1 + "(" + percentage + "%)"

    },
    formatLabel(index) {
      return index.replace("___", "'").replaceAll("_", " ")
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    },
    formatValue(value) {
      if (!value && value !== 0) return '0';
      return value;
    },
    formatPaymentValue(value, index) {
      if (!value && value !== 0) return '0';
      return value;
    },
    getStatCardClass(index) {
      // Add different styling classes based on stat type
      if (index.includes('completed') || index.includes('total')) {
        return 'stat-card-success';
      } else if (index.includes('cancelled') || index.includes('difference')) {
        return 'stat-card-warning';
      }
      return 'stat-card-default';
    }
  }



};
</script>
<style lang="scss" scoped>
.stats-container {
  padding: 20px;
}

.stat-card {
  height: 100%;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
  }

  &.stat-card-success {
    border-left-color: #4caf50;
  }

  &.stat-card-warning {
    border-left-color: #ff9800;
  }

  &.stat-card-default {
    border-left-color: #2196f3;
  }

  &.country-card {
    border-left-color: #9c27b0;
  }

  .stat-label {
    font-size: 0.875rem;
    color: #666;
    font-weight: 500;
    margin-bottom: 8px;
    line-height: 1.4;
    text-transform: capitalize;
  }

  .stat-value {
    font-size: 1.5rem;
    font-weight: 700;
    color: #212121;
    line-height: 1.2;
    word-break: break-word;
  }
}

.v-card__title {
  font-size: 1.25rem;
  font-weight: 600;
  padding: 16px 24px;
}

.v-card__text {
  padding: 16px;
}
</style>
